export const chunkArray = (chunkSize, arr) => {
  if (arr.length <= chunkSize) return [arr]
  const chunkedArr = []
  for (let i = 0; i < Math.ceil(arr.length / chunkSize); i++) {
    chunkedArr[i] = arr.slice(i * chunkSize, i * chunkSize + chunkSize)
  }
  return chunkedArr
}
